import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'

import { DisplayCurrency } from 'app/_shared/interfaces/display-currency'
import { UsdPipe } from 'app/_shared/pipes/currency.pipe'
import { PricePipe } from 'app/_shared/pipes/price.pipe'

@Component({
  selector: 'app-order-summary',
  standalone: true,
  imports: [TranslatePipe, PricePipe, UsdPipe],
  templateUrl: './order-summary.component.html',
  styleUrl: './order-summary.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OrderSummaryComponent {
  displayCurrency = input<DisplayCurrency | null | undefined>(undefined)
  title = input<string>('Summary')
  subtotal = input.required<number>()
  totalDue = input.required<number>()

  tax = input<number | null | undefined>(null)
  shipping = input<number | null | undefined>(null)
  flatOrderFeeAmount = input<number | null | undefined>(null)
  flatOrderFeeLabel = input<string | null | undefined>(null)
  handlingFeeAmount = input<number | null | undefined>(null)
  donation = input<number>(0)
  discount = input<number | null | undefined>(null)

  preDiscountTotal = computed(
    () =>
      this.subtotal() +
      (this.tax() ?? 0) +
      (this.shipping() ?? 0) +
      (this.flatOrderFeeAmount() ?? 0) +
      (this.handlingFeeAmount() ?? 0)
  )

  /** Visibility flags (0 is still “present”) */
  showTax = computed(() => this.tax() !== null && this.tax() !== undefined)
  showShipping = computed(() => this.shipping() !== null && this.shipping() !== undefined)
  showFlatOrderFee = computed(() => (this.flatOrderFeeAmount() ?? 0) > 0)
  showHandlingFee = computed(() => (this.handlingFeeAmount() ?? 0) > 0)
  showDiscount = computed(() => (this.discount() ?? 0) > 0)
}
